import React from 'react';
import pure from 'recompose/pure';
import SvgIcon from './svg/SvgIcon';

const iconStyle = {
  // width: 22,
  // height: 22,
};

const Trash = ({ color, style, ...props }) => (
  /* eslint-disable max-len */
  <SvgIcon {...props} viewBox="0 0 32 32" style={{ ...style, ...iconStyle }}>
    <path
      fill={color || '#C4C8CE'}
      d="M26.13 5.87h-5.332V4.806c0-1.178-.955-2.132-2.133-2.132h-5.33c-1.18 0-2.134.955-2.134 2.132V5.87H5.87v1.067h1.1l1.066 20.26c0 1.177.955 2.132 2.133 2.132h11.728c1.178 0 2.133-.956 2.133-2.134l1.05-20.26h1.05V5.872zM12.267 4.805c0-.588.48-1.066 1.066-1.066h5.33c.59 0 1.067.478 1.067 1.066V5.87h-7.463V4.804zM22.966 27.14l-.002.027v.028c0 .587-.478 1.066-1.066 1.066h-11.73c-.586 0-1.065-.478-1.065-1.065v-.056L8.036 6.935h15.975L22.966 27.14z"
    />
    <path
      fill={color || '#C4C8CE'}
      d="M15.467 9.07h1.066v17.06h-1.066V9.07zM13.358 26.095l-1.09-17.027-1.065.068 1.09 17.027zM20.805 9.103l-1.064-.067-1.075 17.06 1.064.067z"
    />
    />
  </SvgIcon>
  /* eslint-enable max-len */
);

export default pure(Trash);
